// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sn-1";
export var stateContainer = "_sn-0";